<template>
<v-flex class="neg-margin text-xs-center" xs12>
  <div class="neg-margin banner-bg pt-5 elevation-7"><div class="neg-margin pt-5 banner-mask"><div class="neg-fix pt-3">
    <v-layout row wrap justify-center>
      <v-flex class="pb-3" xs12 md10 lg8>
        <v-jumbotron :height="width < 350 ? '650px' : width < 450 ? '450px' : '350px'">
          <v-container grid-list-md fill-height>
            <v-layout align-center justify-center>
              <v-flex class="-text-xs-left" xs12>
                <h1 class="py-3 caps spaced">Nclex RN Review</h1>
                <div class="r-text pb-2">Live and online lectures</div>
                <div class="r-text pb-2">Online access to content review book</div>
                <div class="r-text pb-2">Rophem test bank with over 2000 NCLEX styled question</div>
                <div class="r-text pb-4">One of a kind mock NCLEX exams</div>
                <v-btn to="/register" class="mb-4 caps spaced" color="secondary" large><b>Register</b></v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-jumbotron>
      </v-flex>
    </v-layout>
  </div></div></div>

  <v-layout class="py-4 px-2" row wrap justify-center>
    <v-flex class="pt-3" xs12>
      <h1 class="caps spaced">NCLEX Review Types</h1>
    </v-flex>
    <v-flex class="pb-4 text-xs-left" xs12 md10 lg8>
      <h2 class="mb-0">4-Days Live</h2>
      <p class="r-text">Our tried and true NCLEX review is presented bootcamp style with 4 days in class and 2-3 months online with our 6-Week Plan and test bank. With this course, we recomment purchasing our Rophem Content Review Book, so you can actively follow along in class and engage with the information.</p>
      <p class="r-text">This style has years of results backing up its effectiveness and if you put in the effort to understand the content and think critically through the practice test, you CAN pass the NCLEX!</p>
      <p class="r-text"><b>We also offer Live Online review via Zoom. Rophem Content Review Book not included.</b></p>
    </v-flex>
    <v-flex class="pb-4 text-xs-left" xs12 md10 lg8>
      <h2 class="mb-0">Online (Self-Paced)</h2>
      <p class="r-text">Self-motivated people who can’t physically make it to our live class or simply want to work at their own pace will be successful with our online NCLEX review course! This self-paced course features video and audio lectures that delve into the content and prepare students to think critically when answering questions.</p>
      <p class="r-text mb-2"><b>NCLEX Review and Nursing Remedial Handbooks are sold separately.</b></p>
      <v-btn class="ma-0" color="secondary" to="https://forms.gle/n34i6ZPnDvuWuzTD9">Buy Book</v-btn>
    </v-flex>
    <v-flex class="pb-4 text-xs-left" xs12 md10 lg8>
      <p class="r-text">We’ll celebrate your successes and work with you through your weaknesses to make sure you conquer the NCLEX!</p>
    </v-flex>
    <v-flex class="pb-4" xs12 md10 lg8>
      <v-btn to="/register" class="mb-4 caps spaced" color="secondary" large><b>Register</b></v-btn>
    </v-flex>
  </v-layout>
</v-flex>
</template>

<script>
export default {
  data: () => ({
    tab: '0',
    width: ''
  }),
  computed: {
    screenWidth () {
      return window.innerWidth
    }
  },
  beforeMount () {
    setInterval(() => {
      if (this.width !== window.innerWidth) this.width = window.innerWidth
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/courses/AllCourses.vue